export default __webpack_public_path__ + "static/media/001-Aveiro Lighthouse.28642ad1.svg";